import { useQuery } from '@hooks/reactQuery';

import { getConfigurationTemplateConfigDates } from '@api/configurationTemplates';

import { extractQueryParams } from '@utils/common';
import { parseStringDate } from '@utils/date';

import { IConfigurationTemplateDatesDTO } from '@interfaces/cmModule/dto/configurationTemplatesDTO';
import { IAvailableDates } from '@interfaces/common/common';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { CONFIGURATION_TEMPLATES_CONFIG_DATES } from '@constants/queryKeys';

interface IUseQueryNetworkElementConfigurationDatesReturned {
	configDates: Date[];
	isLoadingConfigDates: boolean;
}

const useQueryConfigurationTemplatesConfigDates = (
	params: Partial<IConfigurationTemplateDatesDTO>,
): IUseQueryNetworkElementConfigurationDatesReturned => {
	const {
		data,
		isInitialLoading,
	} = useQuery<IAvailableDates, Date[]>({
		queryKey: [CONFIGURATION_TEMPLATES_CONFIG_DATES, params],
		queryFn: extractQueryParams(getConfigurationTemplateConfigDates),
		select: (data) => data?.availableDates?.map((date) => parseStringDate(date)) || [],
		enabled: [!!params.configType, !!params.networkElementId],
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		...refetchOptions,
	});

	return {
		configDates: data || [],
		isLoadingConfigDates: isInitialLoading,
	};
};

export default useQueryConfigurationTemplatesConfigDates;
